<template>
	<div>
		<input
				class="form-control"
				v-model="q" @blur="clear"
				type="text" v-on:keydown="search(q)">

		<div>
			<div class="list-group" v-if="result">
				<div class="list-group-item" v-for="r in result" >

					<a href="javascript:void(0)" v-if="r.first_competitor && r.second_competitor" v-on:click="setValue(r.id,r.first_competitor.name+' - '+r.second_competitor.name)">{{ r.first_competitor.name+' - '+r.second_competitor.name }}</a>

				</div>
			</div>
		</div>
		<input
				class="form-control"
				type="hidden"
				v-model="value"
				:disabled="disabled"
				:maxlength="schema.max"
				:placeholder="schema.placeholder"
				:readonly="schema.readonly" >
	</div>
</template>

<script>
    import { abstractField } from "vue-form-generator";

    export default {
        name: 'vfg-field-competitor',
        mixins: [ abstractField ],
        data () {
            return {
                result: null,
                q: '',
            }
        },
        watch: {

        },
        methods: {
            clear () {
                if(!this.q) {
                    this.result = null;
                    this.value = [];
                }
            },
            setValue (val, tit) {
                if(val) {
                    this.value = [];
                    this.value.push(val);

                    this.q = tit;
                    this.result = null;
                }else {
                    this.result = null;
                    this.value = [];
                }

            },
            search (q) {
                this.$http.get(bsapi+'api/v1/search/fixture?q='+this.q+'&type=competitor').then(response => {
                    // get body data
                    this.result = (q) ? response.body.result : null;
                    this.value = [];
                }, response => {
                    this.value = [];
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.list-group {
		background: #fff;
		list-style: none
	}
	.list-group .list-group-item{
		border-bottom: 1px solid #ccc;
		padding: 0px 5px 0px 5px;

	}
</style>



// WEBPACK FOOTER //
// src/components/form/fieldCompetitor.vue